import { Suspense } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import Philosophy from './components/Philosophy';
import Approach from './components/Approach';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        "@id": `${siteUrl}/about`,
        "name": "About Force Multiplier",
        "description": "Learn about the Force Multiplier philosophy and approach to removing structural bottlenecks in founder-led companies.",
        "url": `${siteUrl}/about`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "Force Multiplier",
          "url": siteUrl
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "About",
            "item": `${siteUrl}/about`
          }
        ]
      }
    ]
  };

  return (
    <Suspense fallback={<div className="min-h-screen bg-black" />}>
      <SEOHead
        title="About | Force Multiplier"
        description="Learn about the Force Multiplier philosophy and approach to removing structural bottlenecks in founder-led companies. Strategic advisory for sustainable growth."
        canonicalPath="/about"
        schema={schema}
      />
      <div className="relative min-h-screen bg-black text-white overflow-hidden">
        <Navigation />
        <AboutHero />
        <Philosophy />
        <Approach />
        <AboutCTA />
        <Footer />
      </div>
    </Suspense>
  );
}